import { Missing } from "@tfg/ui"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { useAuth } from "~/store/auth-context"

import { SupplierCell } from "./SupplierCell"

type Props = {
  supplier?: LibraryResponses.Product["lastPendingIrContact"]
}

export const LastPendingIrContactCell = ({ supplier }: Props) => {
  const { isAdmin } = useAuth()

  return (
    <>
      {!supplier || !supplier.email || (supplier.confidential && !isAdmin) ? (
        <Missing />
      ) : (
        <SupplierCell supplierEmail={supplier.email} />
      )}
    </>
  )
}
